import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import SubHeader from './SubHeader';
import StyledTextButton from '../components/StyledTextButton';
import pageImg from '../assets/images/card.svg';
import TermsConditions from '../constants/termsAndConditions';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { styled, useTheme } from '@mui/material';
import {
	formatDateForDisplay,
	getCurrentTimestamp
} from '../utils/dateWrapper';

const StyledListItem = styled('li')(({ theme }) => ({
	margin: '15px 0',
	fontSize: '16px'
}));

const Layout = () => {
	const theme = useTheme();
	const [openTCs, setOpenTCs] = React.useState(false);
	const handleClose = () => {
		setOpenTCs(false);
	};
	return (
		<>
			<Header />
			<Container maxWidth='xl'>
				<SubHeader />
				<Stack
					direction='row'
					justifyContent='center'
					gap={12}
					alignItems='top'
					flexWrap='wrap'
				>
					<Stack width='530px'>
						<img
							src={pageImg}
							alt='a demo rizzbates membership card'
							width='398px'
						/>
						<ul>
							<StyledListItem style={{ fontWeight: 'bold' }}>
								Pay $25/month for the first 4 months and save for the whole
								year. That&apos;s $1,300 in savings for only $100!
							</StyledListItem>
							<StyledListItem>
								$720 yearly in Rebates on your subscription services
							</StyledListItem>
							<StyledListItem>
								20% off everyday savings Gift Cards totaling $480 in yearly
								savings
							</StyledListItem>
							<StyledListItem>
								After your final payment in month 4, you can claim a $100 Dining
								Advantage Gift Card
							</StyledListItem>
							<StyledListItem>
								Chance to win $100 Gift Card just for telling us why you love
								RizzBates on your social accounts
							</StyledListItem>
						</ul>
					</Stack>

					<Stack direction='column' alignItems='center'>
						<Outlet />
						<Box my={3}>
							<StyledTextButton
								size='small'
								onClick={() => setOpenTCs(true)}
								variant='text'
								fontSize='15px'
							>
								Terms and Conditions
							</StyledTextButton>
						</Box>
					</Stack>
				</Stack>
				<Dialog
					fullWidth
					maxWidth='sm'
					onClose={handleClose}
					aria-labelledby='terms_conditions_title'
					open={openTCs}
				>
					<DialogTitle id='terms_conditions_title'>
						Terms and Conditions
					</DialogTitle>
					<DialogContent
						sx={{
							borderRadius: '8px',
							height: '581px',
							maxHeight: '581px',
							overflowY: 'auto',
							fontSize: '15px',
							backgroundColor: (theme) => theme.palette.common.white
						}}
					>
						<TermsConditions />
					</DialogContent>
					<DialogActions sx={{ justifyContent: 'center', my: 2 }}>
						<Button
							size='small'
							sx={{ width: '144px' }}
							onClick={() => setOpenTCs(false)}
						>
							Close
						</Button>
					</DialogActions>
				</Dialog>
				<footer style={{ textAlign: 'center' }}>
					<Typography variant='caption' pb={2}>
						Copyright &copy;{' '}
						{formatDateForDisplay(getCurrentTimestamp(), 'YYYY')} Sempris, LLC.
						All rights reserved.
					</Typography>
				</footer>
			</Container>
		</>
	);
};

export default Layout;
